import React from "react";
import "./styles.scss"

const Viewer2D = ({ image }) => (
    <div className="viewer-2d">
    <img src={`images2D/${image}`} className="image-2d"/>
  </div>
);

  

export default Viewer2D